<section class="feature-section">

    <div class="container-redesign">

        <div class="feature-section__wrapper">

            <div class="feature-section__image">

                <img
                    src="/assets/img/redesign/feature-image.png"
                    alt="Mental health monitoring">

            </div>

            <div class="feature-section__content">

                <h2 class="feature-section__title">
                    Mental health crises
                    are rarely sudden —
                    <span>they’re detected too late</span>
                </h2>

                <p class="feature-section__description">
                    Most critical events in mental healthcare don't happen without warning.
                    Changes in behavior, sleep, medication response, vital signs, or daily
                    patterns often appear first, but in real care environments, those signals
                    are easy to miss.
                </p>

                <p class="feature-section__description">
                    The result is that care becomes reactive by default.
                </p>

                <div class="feature-section__cards">

                    <div class="feature-section__card">
                        SLOWER RESPONSE DURING HIGH-RISK EPISODES.
                    </div>

                    <div class="feature-section__card">
                        INCREASED WORKLOAD FOR ALREADY STRETCHED MENTAL HEALTH TEAMS.
                    </div>

                    <div class="feature-section__card">
                        PREVENTABLE CRISES THAT ESCALATE UNNECESSARILY.
                    </div>

                </div>

                <a
                    routerLink="/contact-redesign"
                    class="feature-section__button">

                    <span>TALK TO OUR TEAM</span>

                    <img
                        src="/assets/img/redesign/flecha.svg"
                        alt=""
                        class="feature-section__button-icon">

                </a>

            </div>

        </div>

    </div>

</section>